import Vue from 'vue'
import { ActionTree, MutationTree } from 'vuex'
import { RootState } from '@/store/types'


export interface State {
  optoins:any
}

const defaultState: State = {
  optoins:null
};

const getters = {
  options: (state: State) => {return {... state.optoins}}
}

const mutations: MutationTree<State> = {
  setOptions (state: State, payload : any) {
    state.optoins = payload
  }
}

const actions: ActionTree<State, RootState> = {
}

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions
}
